import React from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { ScratchpadProvider } from "contexts/ScratchpadProvider";
import { Spinner } from "components/common";
import Scratchpad from "components/scratchpad/Scratchpad";
import CurrentUserContext from "contexts/CurrentUserContext";
import Navigation from "components/navigation/Navigation";
import ReportedErrorBoundary from "components/errors/ReportedErrorBoundary";
import RuntimeErrorBoundary from "components/errors/RuntimeErrorBoundary";
import NavigationTelemetry from "logic/telemetry/NavigationTelemetry";
import HotkeysProvider from "contexts/HotkeysProvider";
import HotkeysModalContainer from "components/hotkeys/HotkeysModalContainer";
import PerspectivesProvider from "components/perspectives/contexts/PerspectivesProvider";
import PageContextProviders from "components/page/contexts/PageContextProviders";
import { singleton } from "logic/singleton";
import DefaultQueryParamProvider from "routing/DefaultQueryParamProvider";
const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const PageContent = styled.div`
  height: 100%;
  overflow: auto;
  flex: 1;
`;
const App = () => /* @__PURE__ */ React.createElement(DefaultQueryParamProvider, null, /* @__PURE__ */ React.createElement(CurrentUserContext.Consumer, null, (currentUser) => {
  if (!currentUser) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(PerspectivesProvider, null, /* @__PURE__ */ React.createElement(HotkeysProvider, null, /* @__PURE__ */ React.createElement(ScratchpadProvider, { loginName: currentUser.username }, /* @__PURE__ */ React.createElement(NavigationTelemetry, null), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AppLayout, null, /* @__PURE__ */ React.createElement(Navigation, null), /* @__PURE__ */ React.createElement(Scratchpad, null), /* @__PURE__ */ React.createElement(ReportedErrorBoundary, null, /* @__PURE__ */ React.createElement(RuntimeErrorBoundary, null, /* @__PURE__ */ React.createElement(PageContextProviders, null, /* @__PURE__ */ React.createElement(PageContent, null, /* @__PURE__ */ React.createElement(Outlet, null)))))), /* @__PURE__ */ React.createElement(HotkeysModalContainer, null)))));
}));
export default singleton("components.App", () => App);
